var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTnTunisia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_24408)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.75 0H-3.75V45H63.75V0Z",
    fill: "#E70013"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5918 22.4824C18.5918 25.4917 19.7872 28.3778 21.9152 30.5057C24.0431 32.6337 26.9291 33.8291 29.9385 33.8291C32.9478 33.8291 35.8339 32.6337 37.9618 30.5057C40.0897 28.3778 41.2852 25.4917 41.2852 22.4824C41.2852 19.4731 40.0897 16.587 37.9618 14.4591C35.8339 12.3312 32.9478 11.1357 29.9385 11.1357C26.9291 11.1357 24.0431 12.3312 21.9152 14.4591C19.7872 16.587 18.5918 19.4731 18.5918 22.4824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9389 30.0059C31.8909 29.9391 33.7406 29.1168 35.0979 27.7124C36.4552 26.3079 37.2139 24.4312 37.2139 22.478C37.2139 20.5249 36.4552 18.6481 35.0979 17.2437C33.7406 15.8392 31.8909 15.0169 29.9389 14.9502C28.9018 14.9502 27.7153 15.1963 26.9155 15.7852C32.4174 15.9873 33.8149 20.6631 33.8149 22.5439C33.8149 24.4248 32.9272 28.6172 26.9155 29.2412C27.601 29.6807 28.9018 30.0059 29.9389 30.0059Z",
    fill: "#E70013"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.3115 25.6465L26.7305 24.3984L28.9893 27.2461L28.8574 23.6162L32.2676 22.3418L28.7695 21.3398L28.6201 17.71L26.5811 20.7246L23.083 19.7578L25.3242 22.6143L23.3115 25.6465Z",
    fill: "#E70013"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_24408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTnTunisia);
export default __webpack_public_path__ + "static/media/tn Tunisia.4359a5a32beeff4f40b0d49ecae70aa5.svg";
export { ForwardRef as ReactComponent };